<template>
  <div class="workflow-update update-form row">
    <div class="col-12">
      <div class="row gutter-lg">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          Status: {{ item.status }}
          <hr>
          <form class="workflow-update--form" @submit.prevent="update">
            <field :errors="errors" name="name" label="models.workflow.name" v-model="item.name" placeholder="My Workflow"></field>

            <field
              :required="true"
              name="scope"
              type="radio"
              model="workflow"
              v-model="workflowScope"
              :collection="workflowScopes"
            />

            <div v-if="workflowScope == 'project'">
              <field
                v-if="projects.length > 0"
                :required="true"
                :errors="errors"
                model="workflow"
                v-can="'projects.list'"
                name="project"
                v-model="item.project_id"
                type="select"
                :params="{no_i18n: true}"
                :collection="projects"
              />
              <p v-else>
                <i>{{ $t('models.workflow.loading_projects') }}</i>
              </p>
            </div>

            <field
              :required="true"
              :errors="errors"
              model="workflow"
              name="frequency"
              type="select"
              v-model="item.frequency"
              :collection="frequencies"
            />

            <field
              v-if="shouldShowDailyRuntime"
              :required="shouldShowDailyRuntime"
              :errors="errors"
              model="workflow"
              name="daily_runtime"
              type="select"
              v-model="item.daily_runtime"
              :collection="hours"
              :params="{no_i18n: true}"
            />

              <div class="field field-text">
                <label for="first_run">{{$t('models.workflow.first_run')}}</label>
                <datetime format="DD/MM/YYYY H:i:s" v-model="firstRun" id="first_run" class="text-input" />
              </div>

              <div class="field field-text">
                <label for="final_run">{{$t('models.workflow.final_run')}}</label>
                <datetime format="DD/MM/YYYY H:i:s" v-model="finalRun" id="final_run" class="text-input" />
              </div>


            <field :errors="errors" @input="executeOnChange" v-can="'is_root'" model="workflow" name="execute_on" type="textarea" :required="true" :value="executeOn"></field>
            <field :errors="errors" @input="configurationChange" v-can="'is_root'" model="workflow" name="configuration" type="textarea" :required="true" :value="configuration"></field>

            <div class="update-form--actions">
              <button class="btn btn-tertiary" @click.prevent="cancel">{{ $t('ui.global.cancel') }}</button>
              <button class="btn btn-primary btn-save" type="submit">{{ $t('ui.global.save') }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/api/Workflow'
import Ui from '@/classes/Ui'
import ProjectApi from '@/api/Project'
import { EventBus } from '@/EventBus.js'
import {updateMixin} from '@/components/mixins/Update'
import frequencies from '@/config/data/frequencies'
import hours from '@/config/data/hours'
import datetime from 'vuejs-datetimepicker'

export default {
  mixins: [updateMixin],
  components: {
    datetime
  },
  computed: {
    executeOn(){
      return JSON.stringify(this.item.execute_on)
    },
    configuration(){
      return JSON.stringify(this.item.configuration)
    },
    firstRun: {
      get() {
        return moment(this.item.first_run).format("DD/MM/YYYY HH:mm:ss")
      },
      set(value) {
        this.item.first_run = moment(value, 'DD/MM/YYYY HH:mm:ss').toDate()
      }
    },
    finalRun: {
      get() {
        return moment(this.item.final_run).format("DD/MM/YYYY HH:mm:ss")
      },
      set(value) {
        this.item.final_run = moment(value, 'DD/MM/YYYY HH:mm:ss').toDate()
      }
    },
    shouldShowDailyRuntime() {
      return this.item.frequency === 'daily'
    }
  },
  data() {
    return {
      api: new Api(),
      model: "workflows",
      projects: [],
      temporaryProjectId: Number,
      frequencies: frequencies,
      hours: hours,
      workflowScope: 'organization',
      workflowScopes: [
          { name: 'organization', value: 'organization' },
          { name: 'project', value: 'project' }
        ],
      headerButtons: [
        { name: "workflow_trigger", action: "workflows.trigger", classes: "btn-primary", icon: "", debounce: 30000 }
      ]
    }
  },
  mounted() {
    this.setupHeader()
    this.retrieve_projects()
    EventBus.$off('action')
    EventBus.$on('action', this.trigger)
  },
  methods: {
    setupHeader() {
      Ui.setHeaderButtons(this.headerButtons)
      Ui.setSubtitle(
        {
          link: {
            name: "workflows"
          }
        }
      )
      Ui.setPageLevel(3)
    },
    async trigger(payload) {
      if (payload == 'workflows.trigger') {
        try {
          let data = await this.api.trigger(this.$route.params.id)
          this.$store.commit('SET_NOTIFICATION', {
            'title': 'models.workflow.message.trigger_success',
            'type': 'success'
          })
        } catch(err) {
          this.$store.commit('SET_NOTIFICATION', {
            'title': 'models.workflow.message.trigger_failed',
            'type': 'error'
          })
        }
      }
    },
    retrieve_projects(){
      let api = new ProjectApi()
      api.all_for_association('name', {sort_by: 'updated_at', sort_order: 'DESC'}).then((items) => {
        this.projects = items
      }).catch(function(error) {
        console.log(error)
      })
    },
    executeOnChange(val){
      try {
        this.item.execute_on = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "execute_on"})
      }
    },
    configurationChange(val){
      try {
        this.item.configuration = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "configuration"})
      }
    },
  },
  watch: {
    'item.project_id' () {
      if (this.item.project_id) {
        // remember project id in case we switch scope to organization and back again to project
        this.temporaryProjectId = this.item.project_id
        this.workflowScope = 'project'
      }
    },
    workflowScope () {
      // reset project_id
      if (this.workflowScope === 'organization') {
        this.item.project_id = null
      }
      if (this.workflowScope === 'project') {
        this.item.project_id = this.temporaryProjectId
      }
    }
  }
}
</script>
<style lang='sass'>
  .workflow-update
    .field input
      margin-bottom: 20px !important
      height: 40px
      padding: 0 10px
    .update-form--actions
      text-align: right
      margin-top: 1.5em
    .datetime-picker
      position: relative
      &:before
        font-family: 'yule-icon-set' !important
        content: '\E904'
        position: absolute
        right: 10px
        top: 10px
        line-height: initial
        color: #9198AB
        font-size: 1.4285rem


    .calender-div
      box-shadow: 0 20px 66px 0 rgba(34, 48, 73, 0.2) !important
      text-align: center
      .headers
        display: flex
        justify-content: space-around
      .year-month-wrapper, .nav-l, .nav-r
        background-color: #fff !important
        color: $ink-lighter !important
      .month-setter, .month, .year, .days
        color: $ink-lighter !important
        font-weight: 400 !important
      .time-picker
        position: absolute
        left: 6px
        margin: 10px 0 !important
      .port:hover, .okButton
        font-weight: 500 !important
      .okButton
        color: $sensual !important
      .port
        border-radius: 50% !important
        width: 40px !important
        height: 40px !important
        line-height: 26px !important
        color: $ink !important
        font-weight: 500 !important
        border: 2px solid transparent !important
        &:hover
          border: 2px solid $sensual !important
          color: $ink !important
      .activePort, li.active
        background-color: $sensual !important
        color: #fff !important
        font-weight: 500 !important
        &:hover
          background-color: $sensual !important
          color: #fff !important
      .scroll-hider
        text-align: left !important
        box-shadow: 0 20px 66px 0 rgba(34, 48, 73, 0.2) !important

  @media(max-width: 575px)
    .workflow-update
      .btn-tertiary
        margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// WorkflowUpdate.vue?57d64b9c